import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

function getSessionId() {
  let sid = sessionStorage.getItem("analytics_sid");
  if (!sid) {
    sid = crypto.randomUUID();
    sessionStorage.setItem("analytics_sid", sid);
  }
  return sid;
}

export function usePageTracking() {
  const location = useLocation();
  const lastPath = useRef("");

  useEffect(() => {
    const fullPath = location.pathname + location.search;
    if (fullPath === lastPath.current) return;
    lastPath.current = fullPath;

    const trackView = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();

        await supabase.functions.invoke("track-pageview", {
          body: {
            page_path: fullPath,
            page_title: document.title,
            referrer: document.referrer || null,
            session_id: getSessionId(),
            user_id: user?.id || null,
          },
        });
      } catch {
        // Silently fail analytics
      }
    };

    // Small delay to let page title update
    setTimeout(trackView, 300);
  }, [location.pathname, location.search]);
}
